export default {
  isLoading: false
}
